import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useCareerAccess } from "../../../logic/hooks/useCareerAccess";

interface CareerAccessGateProps {
    children: ReactNode;
}

export function CareerAccessGate({ children }: CareerAccessGateProps) {
    const access = useCareerAccess();
    if (access === "pending") return null;
    if (access === "denied") return <Navigate to="/" replace />;
    return children;
}
